import { render, staticRenderFns } from "./PaidOffLeasesTabScreen.vue?vue&type=template&id=7b1bc08c&"
import script from "./PaidOffLeasesTabScreen.vue?vue&type=script&lang=js&"
export * from "./PaidOffLeasesTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1bc08c')) {
      api.createRecord('7b1bc08c', component.options)
    } else {
      api.reload('7b1bc08c', component.options)
    }
    module.hot.accept("./PaidOffLeasesTabScreen.vue?vue&type=template&id=7b1bc08c&", function () {
      api.rerender('7b1bc08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeasesScreen/PaidOffLeasesTabScreen.vue"
export default component.exports